import type { SVGAttributes } from "react"

// The ■ mark: one square, one purpose.
export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="9" y="9" width="14" height="14" rx="2" fill="currentColor" />
    </svg>
  )
}
